// extracted by mini-css-extract-plugin
export var item = "styles-module--item--1TPK5";
export var statsOverviewPanel = "styles-module--statsOverviewPanel--2SbkP";